import { ConfigFn } from '@config/types'

const config = (({
  subscriptionCheckerUrl,
  plusSubscriptionServiceUrl,
  baseUrl,
  deploymentEnv,
}) =>
  ({
    conversionUrl: `${subscriptionCheckerUrl}/api/v1/conversion`,
    enableAutoRenewalUrl: `${plusSubscriptionServiceUrl}/subscription/autoRenew`,
    offerPagePath: '/blickplus/abos/',
    faqsLink:
      'https://faq.blick.ch/s/article/Wie-verschenke-ich-einen-Artikel?language=de',
    blickPlusSectionUrl: `${baseUrl}/blickplus/`,
    daysBeforeSubscriptionExpires: 5,
    internalAccessId: '999999',
    footerBannerClassname: 'pianoFixedDiv',
    restrictedDrawerClassname: 'pianoRestrictedDrawer',
    paywallClassName: 'piano-paywall-container',
    notSubscribedResourceIds:
      deploymentEnv === 'prod' ? ['R588ULT'] : ['RXHGXCV', 'RTUNIUF'],
  }) as const) satisfies ConfigFn

export default config
